import type { FC } from "react"
import { useCallback } from "react"
import type { OptionItemVO } from "@/api"
import { createSVGIcon as createSVGIcon1, svgToDataURL as svgToDataURL1 } from "./svg/strokeSvg"
import { createSVGIcon as createSVGIcon2, svgToDataURL as svgToDataURL2 } from "./svg/fillSvg"
// ==============================================
import SvgIcon from "@/components/SvgIcon"
// ==============================================
interface BookmarkTabsProps {
  // 激活项
  activeKey: string
  // 选项
  options: OptionItemVO[]
  // 主题色
  theme?: string
  // 字段
  nameField?: string
  idField?: string
  // 切换activeKey
  onChange?: (key: string) => void
}
const BookmarkTabs: FC<BookmarkTabsProps> = ({
  activeKey,
  options,
  theme,
  nameField = "name",
  idField = "id",
  onChange,
}) => {
  // 点击tab
  const tabClick = useCallback(
    (key) => {
      // 切换activeKey
      onChange && onChange(key)
    },
    [onChange],
  )

  return (
    <div className="bookmark-tabs">
      {options?.map((item) => {
        const tabSvg =
          item[idField] === activeKey
            ? svgToDataURL2(createSVGIcon2(item[nameField], theme))
            : svgToDataURL1(createSVGIcon1(item[nameField]))

        return (
          <div key={item[idField]}>
            <SvgIcon
              className="cursor-pointer"
              title={item[nameField]}
              src={tabSvg}
              onClick={() => tabClick(item[idField])}
            />
          </div>
        )
      })}
    </div>
  )
}

export default BookmarkTabs
